export default function PaymentSection() {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <div className="flex items-center justify-center w-24 h-24 bg-gray-800 rounded-full mx-auto mb-6">
              <i className="ri-bank-card-line text-5xl text-white"></i>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-black mb-6">
              Pagar Mi Deuda
            </h1>
            <div className="w-24 h-1 bg-gray-800 mx-auto mb-8"></div>
            <p className="text-xl text-gray-700">
              Realiza el pago de tu deuda de forma segura y rápida a través de nuestra plataforma de pagos en línea
            </p>
          </div>

          <div className="bg-white p-10 rounded-2xl shadow-xl mb-10">
            <div className="text-center mb-8">
              <div className="flex items-center justify-center w-20 h-20 bg-gray-800 rounded-full mx-auto mb-6">
                <i className="ri-secure-payment-line text-4xl text-white"></i>
              </div>
              <h2 className="text-2xl font-bold text-black mb-4">Pago Seguro en Línea</h2>
              <p className="text-gray-700 mb-8">
                Accede a nuestra pasarela de pagos segura para realizar tu abono o pago total
              </p>
              <a
                href="https://micrositios.avalpaycenter.com/congarantias-ma"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-gray-800 hover:bg-gray-900 text-white px-10 py-4 rounded-lg font-bold text-lg transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                <i className="ri-bank-card-line mr-2"></i>
                Ir a Pagar Ahora
              </a>
            </div>

            <div className="border-t border-gray-200 pt-8">
              <h3 className="text-lg font-bold text-black mb-4 flex items-center gap-2">
                <i className="ri-shield-check-line text-gray-800 text-2xl"></i>
                Notas de Seguridad
              </h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-gray-800 mt-1 flex-shrink-0 text-xl"></i>
                  <span>Tus pagos en línea se procesan a través de una pasarela de pagos segura certificada.</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-gray-800 mt-1 flex-shrink-0 text-xl"></i>
                  <span>Verifica siempre que la dirección web comience con <strong>https://</strong> antes de ingresar tus datos.</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-gray-800 mt-1 flex-shrink-0 text-xl"></i>
                  <span>No compartas tus claves personales ni códigos de verificación con terceros.</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-gray-800 mt-1 flex-shrink-0 text-xl"></i>
                  <span>Guarda siempre el comprobante de pago para tu registro personal.</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-white p-6 rounded-xl shadow-lg text-center">
              <div className="flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full mx-auto mb-4">
                <i className="ri-bank-line text-3xl text-gray-800"></i>
              </div>
              <h3 className="font-bold text-black mb-2">Múltiples Medios</h3>
              <p className="text-gray-600 text-sm">Tarjetas de crédito, débito y PSE</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg text-center">
              <div className="flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full mx-auto mb-4">
                <i className="ri-time-line text-3xl text-gray-800"></i>
              </div>
              <h3 className="font-bold text-black mb-2">Inmediato</h3>
              <p className="text-gray-600 text-sm">Tu pago se refleja al instante</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg text-center">
              <div className="flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full mx-auto mb-4">
                <i className="ri-lock-line text-3xl text-gray-800"></i>
              </div>
              <h3 className="font-bold text-black mb-2">100% Seguro</h3>
              <p className="text-gray-600 text-sm">Certificación PCI DSS</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
